export enum analyticsEventNames {
  USER_LOGGED_IN = 'USER_LOGGED_IN'
}